import { useState } from "react";
import { REJECTION_CODES_TRANSACTION_VALUE_BY_LABEL } from "../../../../../constants/rejectionCodes.constants";
import { buildCodesTableColumnsWithDelete, buildReadOnlyCodesTableColumns, toCodesTableRow, } from "../../../../codesTableColumns";
var toFormValues = function (values) {
    var _a;
    return ({
        code: values.code,
        label: values.label,
        transaction: ((_a = REJECTION_CODES_TRANSACTION_VALUE_BY_LABEL[values.transaction]) !== null && _a !== void 0 ? _a : values.transaction),
        description: values.description,
        action: values.action,
        actionDescription: values.actionDescription,
    });
};
export var useCodesTable = function (props) {
    var _a = useState(undefined), editingId = _a[0], setEditingId = _a[1];
    var columns = props.editable
        ? buildCodesTableColumnsWithDelete(props.onRemoveCode, editingId)
        : buildReadOnlyCodesTableColumns();
    var onEditStart = function (row) { return setEditingId(row.id); };
    var onCancelEdit = function () { return setEditingId(undefined); };
    var onSave = function (row, values) {
        setEditingId(undefined);
        props.onUpdateCode(row.id, toFormValues(values));
    };
    return {
        columns: columns,
        rows: props.codes.map(toCodesTableRow),
        editingId: editingId,
        onEditStart: onEditStart,
        onSave: onSave,
        onCancelEdit: onCancelEdit,
    };
};
